import * as changeCase from 'change-case'
import start from 'lodash.startcase'

export const capitalize = (word: string) => (
  word.charAt(0).toUpperCase() + word.slice(1)
)

export const sentenceCase = changeCase.sentenceCase

export const startCase = (val: string) => start(start(val).toLowerCase())
